<template>
  <v-container>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11>
        <img :src="banner" style="width:100%;" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 md7 lg8 xs12 sm11>
        <!-- video -->
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="typeEstrategico == '1' ">
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h4
                v-if="menor==''"
                class="pull"
              >Proyectando universidad desde las diversas áreas del conocimiento.</h4>
              <h4 v-if="menor!=''" class="pull">{{this.menor.ccNombre}}</h4>
              <p
                class="pull"
              >En base a al proceso de lineamientos estratégicos, los Departamentos, Escuelas y Facultades se han ajustado a las proyecciones del actual PEI 2016 – 2020. Este apartado contiene información propia de cada unidad relacionado con sus respectivos lineamientos, planes operativos e indicadores claves.</p>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md12 lg12 xs12 sm12 v-if="ccComplete.esMayor == true">
              <label class="left" for="sel1">Tus departamentos</label>
              <select class="form-control" id="5" @change="cargaArchivos()" v-model="menor">
                <option selected disabled>-Selecciona una opción-</option>
                <option
                  v-for="(menor,index) in listMenores"
                  :key="index"
                  :value="menor"
                >{{menor.ccNombre}}</option>
              </select>
            </v-flex>
          </v-layout>

          <br />
          <v-flex md12 lg12 xs12 sm12>
            <v-carousel height="350px" :cycle="false" hide-delimiters class="carousel">
              <v-carousel-item v-for="(item,i) in carousel" :key="i" :src="item"></v-carousel-item>
            </v-carousel>
          </v-flex>
        </v-flex>
        <!-- Lineamientos estratégicos -->
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="typeEstrategico == '2' "></v-flex>
      </v-flex>

      <v-flex md1.5 lg xs0 sm0 hidden-sm-and-down>
        <v-layout>
          <v-flex md12 lg12 xs12 sm12>
            <v-navigation-drawer floating permanent stateless class="drawner" value="true">
              <v-list dense>
                <v-list-tile v-for="(button,index) in buttons" :key="index">
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        @click="downloadFile(button.path)"
                        target="_blank"
                      >{{button.title}}</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile
                  v-if="this.$session.getAll().userType == 'Decano' || this.$session.getAll().userType== 'dge'"
                >
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        :to="{name:'indicador'}"
                      >Indicadores</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
          </v-flex>
        </v-layout>
        <!-- <v-layout row>
          <v-flex md10 lg10 xs12 sm11>
            <img :src="asistencia" class="image" @click="dialog = true">
          </v-flex>
        </v-layout>-->
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-navigation-drawer floating permanent stateless class="drawner" value="true">
          <v-list dense>
            <v-list-tile v-for="(button,index) in buttons" :key="index">
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn
                    small
                    color="#EB7704"
                    class="button"
                    @click="downloadFile(button.path)"
                    target="_blank"
                  >{{button.title}}</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn small color="#EB7704" class="button" :to="{name:'indicador'}">Indicadores</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-navigation-drawer>
      </v-flex>
    </v-layout>

    <!-- <v-layout>
      <v-dialog v-model="dialog" width="500px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline">Asistencia DGE</span>
          </v-card-title>
          <div class="form-group">
            <label for="comment">Comenta tus inquietudes</label>
            <textarea class="form-control" rows="5" id="comment"></textarea>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="dialog = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" @click="sendDge">Enviar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>-->
  </v-container>
</template>

<script>
import banner from "../../assets/Captura2.png";
import asistencia from "../../assets/nuevaasistencia.png";

import img1 from "../../assets/carruDepto/1.jpg";
import img2 from "../../assets/carruDepto/2.jpg";
import img3 from "../../assets/carruDepto/3.jpg";
import img4 from "../../assets/carruDepto/4.jpg";
import img5 from "../../assets/carruDepto/5.jpg";
import img6 from "../../assets/carruDepto/6.jpg";
import img7 from "../../assets/carruDepto/7.jpg";
import img8 from "../../assets/carruDepto/8.jpg";
import img9 from "../../assets/carruDepto/9.jpg";
import img10 from "../../assets/carruDepto/10.jpg";
import img11 from "../../assets/carruDepto/11.jpg";
import img12 from "../../assets/carruDepto/12.jpg";
import img13 from "../../assets/carruDepto/13.jpg";
import img14 from "../../assets/carruDepto/14.jpg";
import img15 from "../../assets/carruDepto/15.jpg";
import img16 from "../../assets/carruDepto/16.jpg";
import img17 from "../../assets/carruDepto/17.jpg";
import img18 from "../../assets/carruDepto/18.jpg";

export default {
  data() {
    return {
      carousel: [
        img1,
        img2,
        img3,
        img4,
        img5,
        img6,
        img7,
        img8,
        img9,
        img10,
        img11,
        img12,
        img13,
        img14,
        img15,
        img16,
        img17,
        img18
      ],
      menor: "",
      listMenores: "",
      type: "",
      usuario: "",
      ccComplete: {
        id: "",
        ccValor: "",
        ccNombre: "",
        esMayor: "",
        tipoUnidad: ""
      },
      asistencia: asistencia,
      dialog: false,
      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      filesDge: "",
      banner: banner,
      img2: img2,
      buttons: [
        {
          title: "lineamiento",
          path: "0"
        },
        {
          title: "diagnóstico",
          path: "1"
        },
        {
          title: "plan operativo",
          path: "2"
        }
      ],
      items: [
        { title: "° Video", icon: "dashboard", path: "1" },
        {
          title: "° Lineamientos Estratégicos",
          icon: "dashboard",
          path: "2"
        },
        { title: "° Diagnostico", icon: "question_answer", path: "3" },
        { title: "° Planes Operativos", icon: "question_answer", path: "4" },
        { title: "° Indicadores", icon: "question_answer", path: "5" },
        { title: "° Focus Group", icon: "question_answer", path: "6" }
      ],
      right: null
    };
  },
  created() {
    this.usuario = this.$session.getAll().email;
    this.type = this.$session.getAll().userType;
    this.ccComplete = this.$session.getAll().ccData;
    this.getFiles(this.ccComplete.ccValor);
    axios
      .get(
        process.env.ROOT_API +
          "/centrocosto/getMenoresByccMayor?cc=" +
          this.ccComplete.ccValor,
        this.auth
      )
      .then(response => {
        this.listMenores = response.data;
        //console.log(this.listMenores)
      })
      .catch(error => {
        console.error(error);
      });
  },
  methods: {
    redirect(index) {
      this.typeEstrategico = index;
    },

    getFiles(cc) {
      var cc = cc;
      axios
        .get(
          process.env.ROOT_API + "/uploadFileDcaEtc/getByCcValor?ccValor=" + cc,
          this.auth
        )
        .then(response => {
          this.filesDge = response.data;
          //console.log(this.filesDge);
          //console.log(this.filesDge["dge"][1]);
        })
        .catch(error => {
          console.error(error);
        });
    },

    cargaArchivos() {
      //console.log("Cambiando de departamento "+ this.menor.ccValor)

      this.getFiles(this.menor.ccValor);
    },

    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDge.dge[index]["path"]);
      var nameFile = this.filesDge.dge[index]["name"];
      //console.log(nameFile);
      if (pathFile != "") {
        axios
          .get(
            process.env.ROOT_API +
              "/uploadFileDcaEtc/downloadFile?dir=" +
              pathFile,
            {
              responseType: "arraybuffer",
              headers: { Authorization: "" + this.$session.get("jwt") }
            }
          )
          .then(response => {
            //console.log("archivo descargado ....");
            //console.log(response);
            this.forceFileDownload(response, nameFile);
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        alert("Contenido no disponible");
      }
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },
    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    sendDge() {
      this.dialog = false;
      alert("Tus inquietudes han sido enviadas, pronto te contactaremos.");
    }
  }
};
</script>


<style scoped>
.image {
  cursor: pointer;
}
.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.v-list-new {
  height: 100% !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/diagnosticoEstrategico/Departamento.vue